import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useHistory } from "react-router-dom";
import { Col } from "react-bootstrap";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Switch from "react-switch";
import { NewInputText } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { AddButtonIconComponent } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import {
//   get_new_subscription_for_vendor,
// } from "../../../../../../store/actions/authAction";
import {
  admin_update_new_subscription_for_vendor,
  admin_get_new_subscription_for_vendor,
} from "../../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import store from "../../../../../../store/store";
import { UPDATE_SUBSCRIPTION_TYPE } from "../../../../../../store/types";

export const CasualDiningLiveStreamingScreen = (props) => {
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === "view"
      ? true
      : false
  );
  let history = useHistory();
  const [state, setState] = useState({
    casualLiveStreamingYoutube: false,
    casualLiveStreamingInstagram: false,
    casualLiveStreamingFacebook: false,
    casualLiveStreamingLinkdin: false,
    casualLiveStreamingYoutubeArr: [],
    casualLiveStreamingInstagramArr: [],
    casualLiveStreamingFacebookArr: [],
    casualLiveStreamingLinkdinArr: [],
    errors: {},
  });

  /************** @DESC FocusOut ****************/
  const onFocusOutLink = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    setState({
      ...state,
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
      actionButton: true,
    });
  };

  /************** @DESC Switch Button Handler ****************/
  const casualDiningInsideOfflineEventHandler = (type) => (e) => {
    if (type === "eventYoutubeLink") {
      setState({
        ...state,
        casualLiveStreamingYoutube: !state.casualLiveStreamingYoutube,
        casualLiveStreamingYoutubeArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    } else if (type === "eventInstagramLink") {
      setState({
        ...state,
        casualLiveStreamingInstagram: !state.casualLiveStreamingInstagram,
        casualLiveStreamingInstagramArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    } else if (type === "eventFacebookLink") {
      setState({
        ...state,
        casualLiveStreamingFacebook: !state.casualLiveStreamingFacebook,
        casualLiveStreamingFacebookArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    } else if (type === "eventLinkdinLink") {
      setState({
        ...state,
        casualLiveStreamingLinkdin: !state.casualLiveStreamingLinkdin,
        casualLiveStreamingLinkdinArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Youtube Handlers
   ******************************************/
  const onAddYoutubeHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingYoutubeArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingYoutubeArr: linkDesc,
      });
    }
  };
  const [updated, setUpdate] = useState(false);
  const onYoutubeChangeHandler = (type, index) => (e) => {
    if (e.target.value) {
      setUpdate(true);
    } else {
      setUpdate(false);
    }

    let linkDesc = state.casualLiveStreamingYoutubeArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingYoutubeArr: linkDesc,
    });
  };

  const onYoutubeDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingYoutubeArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({
        ...state,
        casualLiveStreamingYoutubeArr: linkDesc,
        errors: {},
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Instagram Handlers
   ******************************************/
  const onAddInstagramHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingInstagramArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingInstagramArr: linkDesc,
      });
    }
  };

  const onInstagramChangeHandler = (type, index) => (e) => {
    if (e.target.value) {
      setUpdate(true);
    } else {
      setUpdate(false);
    }
    let linkDesc = state.casualLiveStreamingInstagramArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingInstagramArr: linkDesc,
    });
  };

  const onInstagramDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingInstagramArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({
        ...state,
        casualLiveStreamingInstagramArr: linkDesc,
        errors: {},
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Facebook Handlers
   ******************************************/
  const onAddFacebookHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingFacebookArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingFacebookArr: linkDesc,
      });
    }
  };

  const onFacebookChangeHandler = (type, index) => (e) => {
    if (e.target.value) {
      setUpdate(true);
    } else {
      setUpdate(false);
    }
    let linkDesc = state.casualLiveStreamingFacebookArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingFacebookArr: linkDesc,
    });
  };

  const onFacebookDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingFacebookArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({
        ...state,
        casualLiveStreamingFacebookArr: linkDesc,
        errors: {},
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Linkedin Handlers
   ******************************************/
  const onAddLinkdinHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingLinkdinArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingLinkdinArr: linkDesc,
      });
    }
  };

  const onLinkdinChangeHandler = (type, index) => (e) => {
    if (e.target.value) {
      setUpdate(true);
    } else {
      setUpdate(false);
    }
    let linkDesc = state.casualLiveStreamingLinkdinArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingLinkdinArr: linkDesc,
    });
  };

  const onLinkdinDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingLinkdinArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({
        ...state,
        casualLiveStreamingLinkdinArr: linkDesc,
        errors: {},
      });
    }
  };

  useEffect(() => {
    if (props && props?.subscriptionData) {
      let data = props?.subscriptionData;
      setState({
        ...state,
        casualLiveStreamingYoutube:
          props?.subscriptionData.youtube.value === undefined
            ? state.casualLiveStreamingYoutube
            : props?.subscriptionData.youtube.value,
        casualLiveStreamingInstagram:
          props?.subscriptionData.instagram.value === undefined
            ? state.casualLiveStreamingInstagram
            : props?.subscriptionData.instagram.value,
        casualLiveStreamingFacebook:
          props?.subscriptionData.facebook.value === undefined
            ? state.casualLiveStreamingFacebook
            : props?.subscriptionData.facebook.value,
        casualLiveStreamingLinkdin:
          props?.subscriptionData.linkedin.value === undefined
            ? state.casualLiveStreamingLinkdin
            : props?.subscriptionData.linkedin.value,
        casualLiveStreamingYoutubeArr:
          props?.subscriptionData.youtube.sub_values === undefined
            ? state.casualLiveStreamingYoutubeArr
            : props?.subscriptionData.youtube.sub_values,
        casualLiveStreamingInstagramArr:
          props?.subscriptionData.instagram.sub_values === undefined
            ? state.casualLiveStreamingInstagramArr
            : props?.subscriptionData.instagram.sub_values,
        casualLiveStreamingFacebookArr:
          props?.subscriptionData.facebook.sub_values === undefined
            ? state.casualLiveStreamingFacebookArr
            : props?.subscriptionData.facebook.sub_values,
        casualLiveStreamingLinkdinArr:
          props?.subscriptionData.linkedin.sub_values === undefined
            ? state.casualLiveStreamingLinkdinArr
            : props?.subscriptionData.linkedin.sub_values,
      });
    }
  }, [props?.subscriptionData]);

  useEffect(() => {
    let adminVendorId = props?.editDataAction
      ? props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    let formDataId = {
      vendor_id: adminVendorId,
    };
    props.admin_get_new_subscription_for_vendor(formDataId);
  }, []);

  const insideLiveStreamingSubmitClick = (e) => {
    let youtubelinkDesc = state.casualLiveStreamingYoutubeArr;
    let instagramlinkDesc = state.casualLiveStreamingInstagramArr;
    let facebooklinkDesc = state.casualLiveStreamingFacebookArr;
    let linkdinlinkDesc = state.casualLiveStreamingLinkdinArr;
    if (
      youtubelinkDesc[youtubelinkDesc.length - 1].url === "" ||
      youtubelinkDesc[youtubelinkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else if (
      instagramlinkDesc[instagramlinkDesc.length - 1].url === "" ||
      instagramlinkDesc[instagramlinkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else if (
      facebooklinkDesc[facebooklinkDesc.length - 1].url === "" ||
      facebooklinkDesc[facebooklinkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else if (
      linkdinlinkDesc[linkdinlinkDesc.length - 1].url === "" ||
      linkdinlinkDesc[linkdinlinkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      let valuesData = {
        value:
          (state.casualLiveStreamingYoutube &&
            state.casualLiveStreamingYoutubeArr.length > 0 &&
            state.casualLiveStreamingYoutubeArr[0].url) ||
          (state.casualLiveStreamingInstagram &&
            state.casualLiveStreamingYoutubeArr.length > 0 &&
            state.casualLiveStreamingYoutubeArr[0].url) ||
          (state.casualLiveStreamingFacebook &&
            state.casualLiveStreamingInstagramArr.length > 0 &&
            state.casualLiveStreamingInstagramArr[0].url) ||
          (state.casualLiveStreamingLinkdin &&
            state.casualLiveStreamingFacebookArr.length > 0 &&
            state.casualLiveStreamingFacebookArr[0].url)
            ? true
            : false,
        youtube: {
          value:
            state.casualLiveStreamingYoutubeArr.length > 0 &&
            state.casualLiveStreamingYoutubeArr[0].url &&
            state.casualLiveStreamingYoutube
              ? true
              : false,
          sub_values: state.casualLiveStreamingYoutubeArr,
        },
        instagram: {
          value:
            state.casualLiveStreamingInstagramArr.length > 0 &&
            state.casualLiveStreamingInstagramArr[0].url &&
            state.casualLiveStreamingInstagram
              ? true
              : false,
          sub_values: state.casualLiveStreamingInstagramArr,
        },
        facebook: {
          value:
            state.casualLiveStreamingFacebookArr.length > 0 &&
            state.casualLiveStreamingFacebookArr[0].url &&
            state.casualLiveStreamingFacebook
              ? true
              : false,
          sub_values: state.casualLiveStreamingFacebookArr,
        },
        linkedin: {
          value:
            state.casualLiveStreamingLinkdinArr.length > 0 &&
            state.casualLiveStreamingLinkdinArr[0].url &&
            state.casualLiveStreamingLinkdin
              ? true
              : false,
          sub_values: state.casualLiveStreamingLinkdinArr,
        },
      };
      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription?._id;
      let formData = props?.allSubscriptionsData;
      formData.casual_dining_status.live_streaming = valuesData;
      props.admin_update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    }
  };

  const onSuccess = (e) => {
    Alert.success(
      updated
        ? "<h4>Live Streaming subscription updated successfully</h4>"
        : "<h4>Live Streaming subscription added successfully</h4>",
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.push(
      props.editDataAction
        ? "/admin-edit-add-subscription"
        : "/admin-add-subscription"
    );
  };

  const backButtonHandler = (e) => {
    e.preventDefault();
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.push(
      props.editDataAction
        ? "/admin-edit-add-subscription"
        : "/admin-add-subscription"
    );
  };

  if (props?.auth?.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div
                className="col-12 new-subscription-onboarding-component"
                style={{ backgroundColor: "#FFFFFF" }}
              >
                {/* <Media query="(min-width: 992px)">
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    workWithLinkORClick={true}
                    notDisplaProgressBar={true}
                    backButtonClicked={(e) => backButtonHandler(e)}
                  />
                </div>
              </Media> */}
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={true}
                    onLink={
                      props.editDataAction
                        ? "/admin-edit-add-subscription"
                        : "/admin-add-subscription"
                    }
                  />
                </Media>
                <div className="col-8 onboarding_process_screen-button-map inside-subscription-event-section">
                  <div>
                    <TopTextReusableComponent
                      headingText="Live Streaming"
                      headingParagraph="Enter your live streaming information by selection option below"
                    />
                  </div>
                  <div className="row margin-between-toggler inside-event-offline-online-text mt-4">
                    <div className="col-8">
                      <div className="f14-500">Youtube</div>
                      <div className="f11-400 opacity5">
                        Enter your live streaming information for event below
                      </div>
                    </div>
                    <div className="col-4">
                      <Switch
                        checked={state.casualLiveStreamingYoutube}
                        onChange={casualDiningInsideOfflineEventHandler(
                          "eventYoutubeLink"
                        )}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  {state.casualLiveStreamingYoutube ? (
                    <React.Fragment>
                      {state.casualLiveStreamingYoutubeArr.map(
                        (data, index) => (
                          <div
                            className="row inside-event-offline-online-text"
                            key={index}
                          >
                            <div className="col-12">
                              <div className="row mt-4">
                                <Col md={7}>
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="url"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onYoutubeChangeHandler(
                                      "link",
                                      index
                                    )}
                                    maxLength="50"
                                    value={data?.url}
                                    disabled={disabled}
                                    labelText="Stream URL"
                                    errorText={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "*Fields can’t be blank. Please enter your Stream URL"
                                        : null
                                    }
                                    errorTrue={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                  <div className="f11-400 opacity5">
                                    Anyone using these links can watch the live
                                    stream, any violation is subject to review
                                    and flagging the account.
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <NewInputText
                                    extraClass="mb-0 w-100"
                                    name="area"
                                    inputType="text"
                                    disabled={disabled}
                                    onFocusOut={onFocusOutLink}
                                    onChange={onYoutubeChangeHandler(
                                      "business",
                                      index
                                    )}
                                    maxLength="50"
                                    value={data?.area}
                                    labelText="Area of Facility"
                                    errorText={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "*Fields can’t be blank. Please enter your Area of Facility"
                                        : null
                                    }
                                    errorTrue={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                </Col>

                                {state.casualLiveStreamingYoutubeArr.length >
                                1 ? (
                                  <div className="col-1 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                    <div>
                                      <AddButtonIconComponent
                                        // buttonText="Delete"
                                        onClick={onYoutubeDeleteHandler(index)}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                      <div className="col-12 p-0 mb-4 mt-4 restaurant_details_onboarding_minus_button add_email_button flex-wrap">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddYoutubeHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            disabled={disabled}
                          />
                        </div>
                      </div>
                      <hr />
                    </React.Fragment>
                  ) : null}

                  <div className="row margin-between-toggler inside-event-offline-online-text">
                    <div className="col-8">
                      <div className="f14-500">Instagram</div>
                      <div className="f11-400 opacity5">
                        Enter your live streaming information for event below
                      </div>
                    </div>
                    <div className="col-4">
                      <Switch
                        checked={state.casualLiveStreamingInstagram}
                        onChange={casualDiningInsideOfflineEventHandler(
                          "eventInstagramLink"
                        )}
                        disabled={disabled}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </div>
                  {state.casualLiveStreamingInstagram ? (
                    <React.Fragment>
                      {state.casualLiveStreamingInstagramArr.map(
                        (data, index) => (
                          <div
                            className="row inside-event-offline-online-text"
                            key={index}
                          >
                            <div className="col-12">
                              <div className="row mt-4">
                                <Col md={7}>
                                  <NewInputText
                                    disabled={disabled}
                                    extraClass="mb-0"
                                    name="url"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onInstagramChangeHandler(
                                      "link",
                                      index
                                    )}
                                    maxLength="50"
                                    value={data?.url}
                                    labelText="Stream URL"
                                    errorText={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "*Fields can’t be blank. Please enter your Stream URL"
                                        : null
                                    }
                                    errorTrue={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                  <div className="f11-400 opacity5">
                                    Anyone using these links can watch the live
                                    stream, any violation is subject to review
                                    and flagging the account.
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="area"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onInstagramChangeHandler(
                                      "business",
                                      index
                                    )}
                                    disabled={disabled}
                                    maxLength="50"
                                    value={data?.area}
                                    labelText="Area of Facility"
                                    errorText={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "*Fields can’t be blank. Please enter your Area of Facility"
                                        : null
                                    }
                                    errorTrue={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                </Col>
                                {state.casualLiveStreamingInstagramArr.length >
                                1 ? (
                                  <div className="col-1 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                    <div>
                                      <AddButtonIconComponent
                                        // buttonText="Delete"
                                        onClick={onInstagramDeleteHandler(
                                          index
                                        )}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                      <div className="col-12 p-0 mb-4 mt-4 restaurant_details_onboarding_minus_button add_email_button flex-wrap">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddInstagramHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            disabled={disabled}
                          />
                        </div>
                      </div>
                      <hr />
                    </React.Fragment>
                  ) : null}

                  <div className="row margin-between-toggler inside-event-offline-online-text">
                    <div className="col-8">
                      <div className="f14-500">Facebook</div>
                      <div className="f11-400 opacity5">
                        Enter your live streaming information for event below
                      </div>
                    </div>
                    <div className="col-4">
                      <Switch
                        checked={state.casualLiveStreamingFacebook}
                        onChange={casualDiningInsideOfflineEventHandler(
                          "eventFacebookLink"
                        )}
                        disabled={disabled}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </div>
                  {state.casualLiveStreamingFacebook ? (
                    <React.Fragment>
                      {state.casualLiveStreamingFacebookArr.map(
                        (data, index) => (
                          <div
                            className="row inside-event-offline-online-text"
                            key={index}
                          >
                            <div className="col-12">
                              <div className="row mt-4">
                                <Col md={7}>
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="url"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onFacebookChangeHandler(
                                      "link",
                                      index
                                    )}
                                    disabled={disabled}
                                    maxLength="50"
                                    value={data?.url}
                                    labelText="Stream URL"
                                    errorText={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "*Fields can’t be blank. Please enter your Stream URL"
                                        : null
                                    }
                                    errorTrue={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                  <div className="f11-400 opacity5">
                                    Anyone using these links can watch the live
                                    stream, any violation is subject to review
                                    and flagging the account.
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="area"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onFacebookChangeHandler(
                                      "business",
                                      index
                                    )}
                                    disabled={disabled}
                                    maxLength="50"
                                    value={data?.area}
                                    labelText="Area of Facility"
                                    errorText={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "*Fields can’t be blank. Please enter your Area of Facility"
                                        : null
                                    }
                                    errorTrue={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                </Col>
                                {state.casualLiveStreamingFacebookArr.length >
                                1 ? (
                                  <div className="col-1 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                    <div>
                                      <AddButtonIconComponent
                                        // buttonText="Delete"
                                        onClick={onFacebookDeleteHandler(index)}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                      <div className="col-12 p-0 mb-4 mt-4 restaurant_details_onboarding_minus_button add_email_button  flex-wrap">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddFacebookHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            disabled={disabled}
                          />
                        </div>
                      </div>
                      <hr />
                    </React.Fragment>
                  ) : null}

                  <div className="row margin-between-toggler inside-event-offline-online-text">
                    <div className="col-8">
                      <div className="f14-500">Linkedin</div>
                      <div className="f11-400 opacity5">
                        Enter your live streaming information for event below
                      </div>
                    </div>
                    <div className="col-4">
                      <Switch
                        checked={state.casualLiveStreamingLinkdin}
                        onChange={casualDiningInsideOfflineEventHandler(
                          "eventLinkdinLink"
                        )}
                        disabled={disabled}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={16}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={10}
                        width={27}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                    </div>
                  </div>
                  {state.casualLiveStreamingLinkdin ? (
                    <React.Fragment>
                      {state.casualLiveStreamingLinkdinArr.map(
                        (data, index) => (
                          <div
                            className="row inside-event-offline-online-text"
                            key={index}
                          >
                            <div className="col-12">
                              <div className="row mt-4">
                                <Col md={7}>
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="url"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onLinkdinChangeHandler(
                                      "link",
                                      index
                                    )}
                                    maxLength="50"
                                    value={data?.url}
                                    disabled={disabled}
                                    labelText="Stream URL"
                                    errorText={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "*Fields can’t be blank. Please enter your Stream URL"
                                        : null
                                    }
                                    errorTrue={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.url === "" &&
                                      state.errors.url ===
                                        "*Fields can’t be blank. Please enter your url"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                  <div className="f11-400 opacity5">
                                    Anyone using these links can watch the live
                                    stream, any violation is subject to review
                                    and flagging the account.
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <NewInputText
                                    extraClass="mb-0"
                                    name="area"
                                    inputType="text"
                                    onFocusOut={onFocusOutLink}
                                    onChange={onLinkdinChangeHandler(
                                      "business",
                                      index
                                    )}
                                    maxLength="50"
                                    value={data?.area}
                                    disabled={disabled}
                                    labelText="Area of Facility"
                                    errorText={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "*Fields can’t be blank. Please enter your Area of Facility"
                                        : null
                                    }
                                    errorTrue={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? true
                                        : false
                                    }
                                    controlClass={
                                      data?.area === "" &&
                                      state.errors.area ===
                                        "*Fields can’t be blank. Please enter your area"
                                        ? "outlined-error-helper-text"
                                        : "outlined-helperText "
                                    }
                                  />
                                </Col>
                                {state.casualLiveStreamingLinkdinArr.length >
                                1 ? (
                                  <div className="col-1 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                    <div>
                                      <AddButtonIconComponent
                                        buttonText="Delete"
                                        onClick={onLinkdinDeleteHandler(index)}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                        disabled={disabled}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                      <div className="col-12 p-0 mb-4 mt-4 restaurant_details_onboarding_minus_button add_email_button flex-wrap">
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddLinkdinHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            disabled={disabled}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}

                  <div className="onboarding-map-setup-screen-autodetect-button ">
                    <ReusableOnboardingButton
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      buttonType="button"
                      onClick={(e) => backButtonHandler(e)}
                    />
                    {!disabled && (
                      <ReusableOnboardingButton
                        buttonTitle="Next Button"
                        buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        buttonText="Done"
                        buttonType="button"
                        onClick={insideLiveStreamingSubmitClick}
                        disabled={disabled}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

CasualDiningLiveStreamingScreen.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  subscriptionData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status &&
    state?.superAdminOnboarding?.onboard_subscription_details
      ?.casual_dining_status?.live_streaming,
  allSubscriptionsData:
    state?.superAdminOnboarding &&
    state?.superAdminOnboarding?.onboard_subscription_details,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});

export default connect(mapStateToProps, {
  admin_update_new_subscription_for_vendor,
  admin_get_new_subscription_for_vendor,
})(withRouter(CasualDiningLiveStreamingScreen));
//4-05-2021
